export const SET_CODECS = "SET_CODECS";
export const ADD_CODEC_TO_LIST = "ADD_CODEC_TO_LIST";
